/**
 * Wrapper around Adobe Carousel clientlibs
 * @type {Object}
 */
export const carouselAdobe = {
  /**
   * init method to run adobe clientlibs
   * @return {void}
   */
  init() {
    try {
      // these are not ES Modules, they are IIFEs that are run as soon as imported
      require('../../../dist/ehi_cheerios/adobe/carousel/v1/carousel/clientlibs/site/js/carousel.js');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('[ERROR] Issue loading Adobe Core Carousel Component clientlibs.', e);
    }
  }
}
